<template>
  <div>
    <!-- Trigger the modal with a button -->
    <button type="button" class="btn btn-primary pull-right" data-toggle="modal" :data-target="solutionKeyHash" @click.prevent="getSolution">{{$t('pages.exercise.solvedText')}}</button>

    <!-- Modal-->
    <div class="modal fade" :id="solutionKeyId" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content -->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{$t('pages.exercise.solvedText')}}</h4>
          </div>
          <div class="modal-body">
            <!--Ovde je klasicno kada postoji resenje jos u CelotnoVprasanje-->
            <div v-if="CelotnoVprasanje.solution != null" v-html="translateVhtml(CelotnoVprasanje.solution.sl)"></div>

            <!-- Nima resenja ali je parametricna ali subgroup -->
            <div v-else-if="fullExercise != undefined && fullExercise.data.parent == null && fullExercise.data.questions[i].solution != undefined">
              <!--subgroup exercise, samo resenje je dosta ne trebaju nikakve poruke-->
              <div v-html="translateVhtml(fullExercise.data.questions[i].solution.sl)"></div>
            </div>

            <div v-else-if="fullExercise != undefined && fullExercise.data.parent != null && fullExercise.data.questions[i].solution != undefined">
              <!-- text "Parametrica naloga, tuki je resitev parenta" -->
              <p>{{$t('pages.exercise.answers.parametricSolution')}}</p>
              <div v-html="translateVhtml(fullExercise.data.text.sl)"></div>
              <div v-html="translateVhtml(fullExercise.data.questions[i].text.sl)"></div>
              <div v-html="translateVhtml(fullExercise.data.questions[i].solution.sl)"></div>
            </div>
            <!-- Nima resitve -->
            <p v-else-if="fullExercise == undefined || fullExercise.data.questions[i].solution == null">{{$t('pages.exercise.answers.noSolution')}}</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import exerciseEvaluation from '@/components/mixins/ExerciseEvaluation.vue'

export default{
  data () {
    return {
      // solutionKeyId: this.solutionKeyId,
      solutionKeyHash: '#' + this.solutionKeyId,
      fullExercise: null,
      submitInfo: {
        identifier: this.identifier,
        parentIdentifier: this.parentIdentifier,
        exerciseVersionId: this.exerciseVersionId
      }
    }
  },
  props: ['CelotnoVprasanje', 'solutionKeyId', 'i', 'identifier', 'exerciseVersionId', 'parentIdentifier'],
  methods: {
    getSolution () {
      if (this.fullExercise === null && this.CelotnoVprasanje.solution == null) {
        this.$store.dispatch('showSolutionNew', this.submitInfo).then((data) => {
          this.fullExercise = data
        }).then(() => {
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
          })
        })
      }
    }
  },
  mixins: [exerciseEvaluation]
}
</script>




// WEBPACK FOOTER //
// SolutionModal.vue?13a1c200